<template>
  <div>
   <b-container>
     <b-row class="d-none d-md-block">
       <b-col class="mt-md-3">
         <h4 class="sub-heading text-center">
           Bitte geben Sie den zu zahlenden Betrag ein und wählen Sie die gewünschte Zahlungsweise aus.
         </h4>
       </b-col>
     </b-row>
     <b-row class="d-md-none">
       <b-col class="mt-md-3">
         <p class="sub-heading text-center font-weight-bold">
           Bitte geben Sie den zu zahlenden Betrag ein und wählen Sie die gewünschte Zahlungsweise aus.
         </p>
       </b-col>
     </b-row>
     <b-row class="mt-md-5 no-gutters">
       <b-col class="ml-3 col-xs-3 col-lg-2">
         Datum:
       </b-col>
       <b-col>
         {{ getDate() }}
       </b-col>
     </b-row>
     <b-row class="no-gutters">
       <b-col class="ml-3 col-xs-3 col-lg-2">
         Kundennummer:
       </b-col>
       <b-col>
         {{ custNo }}
       </b-col>
     </b-row>
     <b-row class="border-top no-gutters">
       <b-col>
         <b-container>
           <b-row class="mt-5 no-gutters">
             <b-col class="col-xs-2 col-md-3 col-lg-2">Betrag: </b-col>
             <b-col class="col-xs-3 col-md-3">
               <b-form-input
                 ref="amount"
                 v-model="amount"
                 class="text-left"
                 @focus="$event.target.select()"
                 @change="validateAmount"
                 @keyup.enter="startPayment">

               </b-form-input>
             </b-col>
           </b-row>
           <b-row class="mt-2 no-gutters">
             <b-col class="col-xs-2 col-md-3 col-lg-2">Zahlungsweise: </b-col>
             <b-col class="col-xs-3 col-md-3">
               <b-form-select
                 v-model="selected"
                 :options="paymentProvider"
                 :state="state"
                 @keyup.enter="startPayment">

               </b-form-select>
             </b-col>
           </b-row>
           <b-row class="mt-2 no-gutters">
             <b-col class="col-xs-4 col-md-3 col-lg-2">Ich habe bereits eine Sperrankündigung erhalten oder meine Versorgung wurde bereits unterbrochen. </b-col>
             <b-col class="col-xs-3 col-md-3">
               <b-form-checkbox
                 id="priobox"
                 v-model="priority"
                 name="priobox"
                 value="true"
                 unchecked-value="false"
                 size="lg"
               >
               </b-form-checkbox>
             </b-col>
             <div class="w-100 pt-2 d-sm-none"></div>
             <b-col cols="1" class="mb-2 ml-md-2">
               <b-button @click="startPayment()" class="btn-evm-orange">
                 <b-spinner small v-if="loading"></b-spinner>
                 <div v-else>Bezahlen</div>
               </b-button>
             </b-col>
           </b-row>
           <b-row v-if="msg" class="mb-2">
             <b-col class="text-danger mt-2">
               {{ msg }}
             </b-col>
           </b-row>
         </b-container>
       </b-col>
     </b-row>
   </b-container>
    <b-container class="mt-5">
      <b-row class="ml-3">
        <!--<b-col class="col-4 col-md-3 col-lg-2 mt-md-5">
          <a href="https://www.klarna.com/sofort/" target="_blank"><img src="../assets/sofort_logo.png" style="max-width: 70%;" class=" mb-1"/></a>
        </b-col>-->
        <b-col class="col-4 col-md-3 col-lg-2 mt-md-5">
          <a href="https://www.barzahlen.de/de/privatkunden/so-funktionierts" target="_blank"><img src="../assets/barzahlen-logo.png" style="max-width: 70%;" class=" mb-1" /></a>
        </b-col>
        <b-col class="col-4 col-md-3 col-lg-2 mt-md-5">
          <a href="https://www.paypal.com/de/webapps/mpp/personal" target="_blank"><img src="../assets/paypal_logo.jpg" style="max-width: 70%;" class=" mb-1" /></a>
        </b-col>
      </b-row>
    </b-container>
    <barzahlen-modal ref="barzahlenModal" @pay="startBarzahlenPayment"/>
    <mail-modal ref="mailModal" @pay="startPayPalPayment"/>
  </div>
</template>

<script>

import { ApiCalls } from '../scripts/ApiCalls'
import moment from 'moment'
import BarzahlenModal from '@/components/barzahlenModal'
import MailModal from '@/components/emailModal'

export default {
  name: 'PaymentSelection',
  components: { MailModal, BarzahlenModal },
  data () {
    return {
      custNo: '',
      amount: 0,
      msg: '',
      selected: null,
      state: null,
      priority: 'false',
      paymentProvider: [
        { value: null, text: 'Bitte Zahlungsweise wählen.', disabled: true },
        { value: 'PAYPAL', text: 'PayPal' },
        // { value: 'SU', text: 'Sofortüberweisung' },
        { value: 'bar', text: 'Barzahlen.de' }
      ],
      loading: false
    }
  },
  created () {
    this.amount = '0,00 €'
    this.getCustomerData()
  },
  methods: {
    validateAmount () {
      this.amount = this.amount.replace(' ', '').replace('€', '')
      let regex = /^\d{1,8}(,\d{1,2})?$/
      this.msg = ''
      if (!this.amount.match(regex) ||
        this.amount === '0,00' ||
        this.amount === '0,0' ||
        this.amount === '0') {
        this.msg = 'Bitte einen gültigen Betrag eingeben. Z.B. 500 € oder 294,50 €.'
        return false
      } else if (this.selected === 'bar') {
        if (this.amount > 999.0) {
          this.msg = 'Für Barzahlen.de sind leider nur Beträge bis maximal 999 € möglich.'
          return false
        }
      }
      this.amount = this.amount + ' €'
      return true
    },
    startPayment () {
      this.state = null
      this.msg = ''
      if (this.validateAmount()) {
        if (!this.selected) {
          this.state = false
          this.msg = 'Bitte Zahlungsweise auswählen.'
        } else {
          if (this.selected === 'bar') {
            this.$refs['barzahlenModal'].show()
          } else {
            if (localStorage.custNo) {
              if (this.selected === 'PAYPAL') {
                this.$refs['mailModal'].show()
              } else {
                this.loading = true
                ApiCalls.startPayment(localStorage.custNo, this.selected, this.amount, this.priority).then(res => {
                  console.log(res)
                  if (res.startsWith('http')) {
                    window.location = res
                  } else if (res === 'NOT_FOUND') {
                    this.loading = false
                    this.msg = 'Kundennummer nicht gefunden. Bitte loggen Sie sich neu ein.'
                  } else {
                    this.loading = false
                    this.msg = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später nochmal.'
                  }
                }).catch(error => {
                  this.loading = false
                  alert('Es ist ein Fehler aufgetreten: ' + error)
                })
              }
            } else {
              alert('Customer not found')
            // this.$router.replace({ name: 'start' })
            }
          }
        }
      }
    },
    startBarzahlenPayment (contactType, contact) {
      this.loading = true
      this.$refs['barzahlenModal'].hide()
      ApiCalls.startPayment4Barzahlen(localStorage.custNo, 'bar', contactType, contact, this.amount, this.priority).then(res => {
        console.log(res)
        if (res === 'OK') {
          this.$router.replace({ name: 'callback' })
        } else if (res === 'NOT_FOUND') {
          this.msg = 'Kundennummer nicht gefunden. Bitte loggen Sie sich neu ein.'
        } else {
          this.msg = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später nochmal.'
        }
      }).catch(error => {
        alert('Es ist ein Fehler aufgetreten: ' + error)
      })
    },
    startPayPalPayment (mail) {
      this.$refs['mailModal'].hide()
      this.loading = true
      ApiCalls.startPayPalPayment(localStorage.custNo, this.selected, this.amount, mail, this.priority).then(res => {
        console.log(res)
        if (res.startsWith('http')) {
          window.location = res
        } else if (res === 'NOT_FOUND') {
          this.loading = false
          this.msg = 'Kundennummer nicht gefunden. Bitte loggen Sie sich neu ein.'
        } else {
          this.loading = false
          this.msg = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später nochmal.'
        }
      }).catch(error => {
        this.loading = false
        alert('Es ist ein Fehler aufgetreten: ' + error)
      })
    },
    getCustomerData () {
      if (this.$route.query.userid && this.$route.query.amount) {
        localStorage.custNo = decodeURI(this.$route.query.userid)
        this.amount = String((this.$route.query.amount / 100).toFixed(2)).replace('.', ',') + ' €'
      }
      if (localStorage.custNo && localStorage.custNo !== 'null') {
        console.log(this.$route.query.userid + ' - ' + this.$route.query.amount)
        ApiCalls.getCustomerPayment(localStorage.custNo).then(res => {
          if (res.custNo) {
            this.custNo = res.custNo
          } else {
            alert('Kundenummer nicht gefunden')
            this.$router.replace({ name: 'start' })
          }
        }).catch(error => {
          alert('Es ist ein Fehler aufgetreten: ' + error)
        })
      } else {
        alert('Kunde nicht gefunden')
        // this.$router.replace({ name: 'start' })
      }
    },
    getDate () {
      return moment().format('DD.MM.YYYY')
    },
    formatAmount: function (value) {
      if (typeof value !== 'number') {
        return value
      }
      let formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      })
      return formatter.format(value)
    }
  }
}
</script>

<style lang="css">

  .invoice-table-desc td {
    font-size: 14px
  }

  .btn-evm-orange {
    background-color: rgb(243, 145, 0);
    border-color: rgb(243, 145, 0);
  }
</style>
